import { render, staticRenderFns } from "./StaticData.vue?vue&type=template&id=0fa3885c"
import script from "./StaticData.vue?vue&type=script&lang=js"
export * from "./StaticData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports